class Radio {
    functions = [];

    constructor() {

    }

    on(label, func) {
        if (this.functions[label]) {
            this.functions[label].push(func);
        } else {
            this.functions[label] = [func];
        }
    }

    remove(func) {
        this.functions.splice(this.functions.indexOf(func));
    }

    trigger(label) {
        if (this.functions[label]) {
            this.functions[label].forEach((fn) => fn());
        }
    }
}
const radio = new Radio;
export default radio;
